module.exports = __webpack_public_path__ + "static/media/oral.cbffdd1f.svg";